import React, { useEffect, useState } from "react";
import { Pagination } from "react-bootstrap";
import "./Pagination.css";
import { formatMessage } from "../../translations/format-message";

type PropTypes = {
  totalPages: number;
  pageLimit: number;
  onPageChanged: Function;
  disablePagination: boolean;
  isRefreshPage: boolean;
  setIsRefreshPage: Function;
};

const ApplicationPagger = (props: PropTypes) => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [currentSet, setCurrentSet] = useState<number>(1); 

  let { totalPages, onPageChanged, disablePagination, isRefreshPage } = props;
  if (totalPages === 0) totalPages = 1;

  useEffect(() => {
    onPageChanged(1);
    setCurrentPage(1);
    setCurrentSet(1);
  }, [props.pageLimit]);

  useEffect(() => {
    if (isRefreshPage) {
      setCurrentPage(1);
      setCurrentSet(1);
      props.setIsRefreshPage();
    }
  }, [isRefreshPage]);

  useEffect(() => {
    onPageChanged(currentPage);
  }, [currentPage]);

  const gotoPage = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      setCurrentSet(Math.ceil(page / 3)); 
    }
  };

  const handleMoveFirst = () => gotoPage(1);
  const handleMoveLast = () => gotoPage(totalPages);
  const handleMoveNext = () => gotoPage(currentPage + 1);
  const handleMovePrev = () => gotoPage(currentPage - 1);

  const startPage = (currentSet - 1) * 3 + 1;
  const endPage = Math.min(startPage + 2, totalPages);

  return (
    <div className="panelTablePagination d-flex justify-content-center">
      <Pagination>
        {/* <Pagination.First
          onClick={handleMoveFirst}
          disabled={disablePagination || currentPage === 1}
        /> */}
        <Pagination.Prev
          onClick={handleMovePrev}
          className="end-link"
          disabled={disablePagination || currentPage === 1}
        >
            <svg id="fi_5343109" height="12" viewBox="0 0 512 512" width="12" className="me-2" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1"><path d="m390.627 54.627-201.372 201.373 201.372 201.373a32 32 0 1 1 -45.254 45.254l-224-224a32 32 0 0 1 0-45.254l224-224a32 32 0 0 1 45.254 45.254z"></path></svg>
          {formatMessage("previous")}
        </Pagination.Prev>

        {/* Show left ellipsis if not in the first set */}
        {startPage > 1 && (
          <Pagination.Ellipsis onClick={() => setCurrentSet(currentSet - 1)} />
        )}

        {/* Display the current set of three pages */}
        {Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i).map(
          (page) => (
            <Pagination.Item
              key={page}
              active={page === currentPage}
              onClick={() => gotoPage(page)}
            >
              {page}
            </Pagination.Item>
          )
        )}

        {/* Show right ellipsis if more pages exist */}
        {endPage < totalPages && (
          <Pagination.Ellipsis onClick={() => setCurrentSet(currentSet + 1)} />
        )}

        <Pagination.Next
          onClick={handleMoveNext}
          className="end-link"
          disabled={disablePagination || currentPage === totalPages}
        >
            {formatMessage("next")}
            <svg id="fi_5343102" height="12" className="ms-2" viewBox="0 0 512 512" width="12" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1"><path d="m121.373 457.373 201.372-201.373-201.372-201.373a32 32 0 0 1 45.254-45.254l224 224a32 32 0 0 1 0 45.254l-224 224a32 32 0 0 1 -45.254-45.254z"></path></svg>
          
        </Pagination.Next>
        {/* <Pagination.Last
          onClick={handleMoveLast}
          disabled={disablePagination || currentPage === totalPages}
        /> */}
      </Pagination>
    </div>
  );
};

export default ApplicationPagger;
